import { render, staticRenderFns } from "./EnacAtplDashboardSkillsTestLearners.vue?vue&type=template&id=34e3dc87"
import script from "./EnacAtplDashboardSkillsTestLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardSkillsTestLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports